import * as Amount from '@ssc-booking/api-contracts/src/amount';
import { formatAmount } from "../../../_common/format/localization"

export const noFlightKey = "no-flight"

export const formatFlightPrice = (amount: Amount.Amount): string => `+${formatAmount(amount)}`
